/**
 * The line break character.
 *
 * @private
 * @since 0.1.0
 */
export const LINE_BREAK = '\n';

/**
 * The space that has no width.
 *
 * @private
 * @since 0.1.0
 */
export const ZERO_WIDTH_SPACE = '\ufeff';
